export default __webpack_public_path__ + "static/media/nodeR.f99dcd15.png";